(() => {
  const root = document.querySelector('[data-sw-cod-checkout]');
  const params = new URLSearchParams(window.location.search);

  if (!root || params.get('cod') !== '1') return;

  document.documentElement.classList.add('sw-cod-mode');
  root.hidden = false;

  const supported = new Set(['EG', 'SA', 'AE', 'OM', 'IQ']);
  const country = String(root.dataset.country || '').toUpperCase();
  const apiBase = String(root.dataset.apiBase || '').replace(/\/$/, '');
  const googleAdsSendTo = String(root.dataset.googleAdsSendTo || '').trim();

  const form = root.querySelector('[data-sw-cod-form]');
  const province = root.querySelector('select[name="provinceId"]');
  const submit = root.querySelector('[data-sw-cod-submit]');
  const errorBox = root.querySelector('[data-sw-cod-error]');
  const loading = root.querySelector('[data-sw-cod-loading]');
  const ready = root.querySelector('[data-sw-cod-ready]');
  const itemsBox = root.querySelector('[data-sw-cod-items]');
  const success = root.querySelector('[data-sw-cod-success]');
  const workspace = root.querySelector('[data-sw-cod-workspace]');
  const countryLabels = root.querySelectorAll('[data-sw-country-label]');
  const summary = root.querySelector('.sw-cod-checkout__summary');
  const summaryToggle = root.querySelector('[data-sw-summary-toggle]');
  const summaryToggleLabel = root.querySelector('[data-sw-summary-toggle-label]');
  const summaryTotal = root.querySelector('[data-sw-summary-total]');
  const subtotalNode = root.querySelector('[data-sw-subtotal]');
  const shippingNode = root.querySelector('[data-sw-shipping]');
  const totalNode = root.querySelector('[data-sw-total]');

  const locale = document.documentElement.lang || 'ar-EG';

  const money = (value, currency) => {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return '—';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        maximumFractionDigits: currency === 'IQD' ? 0 : currency === 'OMR' ? 3 : 2
      }).format(amount);
    } catch {
      return amount + ' ' + currency;
    }
  };

  const friendlyError = message => {
    const value = String(message || '').toLowerCase();

    if (value.includes('invalid phone')) return 'أدخل رقم هاتف صحيح.';
    if (value.includes('invalid customer name')) return 'أدخل الاسم الأول بشكل صحيح.';
    if (value.includes('invalid address')) return 'أدخل عنوانًا واضحًا ومفصلًا.';
    if (value.includes('invalid province')) return 'اختر محافظة صحيحة.';
    if (value.includes('province') && value.includes('required')) return 'اختر المحافظة أولًا.';
    if (value.includes('variant not available') || value.includes('variant no longer available')) {
      return 'أحد المنتجات لم يعد متاحًا. ارجع للسلة وحدّث طلبك.';
    }
    if (value.includes('product unavailable') || value.includes('product no longer available')) {
      return 'أحد المنتجات نفد أو لم يعد متاحًا.';
    }
    if (value.includes('price') || value.includes('تغير سعر')) {
      return 'تم تحديث سعر أحد المنتجات. راجع الإجمالي الجديد ثم حاول مرة أخرى.';
    }
    if (value.includes('order submission already in progress')) return 'جاري تأكيد نفس الطلب بالفعل. انتظر لحظات.';
    if (value.includes('unable to verify duplicate order')) return 'تعذر التحقق من حالة الطلب مؤقتًا. أعد المحاولة بعد قليل.';
    if (value.includes('rate limit')) return 'محاولات كثيرة خلال وقت قصير. حاول مرة أخرى بعد قليل.';
    if (value.includes('origin not allowed')) return 'تعذر التحقق من مصدر الطلب.';
    if (value.includes('quote token')) return 'تعذر إنشاء إجمالي صالح للطلب. أعد المحاولة.';
    if (value.includes('failed to load provinces')) return 'تعذر تحميل المحافظات حاليًا. حاول مرة أخرى.';
    if (value.includes('failed to load products') || value.includes('failed to load variant') || value.includes('failed to validate variant')) {
      return 'تعذر التحقق من بيانات المنتج حاليًا. أعد المحاولة.';
    }
    if (value.includes('shopify auth failed')) return 'تعذر التحقق من الطلب حاليًا.';
    if (value.includes('network')) return 'تعذر الاتصال بالخدمة. تحقق من الإنترنت وحاول مرة أخرى.';

    return message || 'حدث خطأ غير متوقع. حاول مرة أخرى.';
  };

  const fail = message => {
    if (!errorBox) return;
    errorBox.textContent = friendlyError(message);
    errorBox.hidden = false;
    errorBox.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  };

  const clearError = () => {
    if (!errorBox) return;
    errorBox.hidden = true;
    errorBox.textContent = '';
  };

  const safeSessionValue = key => {
    try {
      return String(sessionStorage.getItem(key) || '').trim();
    } catch {
      return '';
    }
  };

  const getAttribution = () => ({
    gclid: safeSessionValue('sw_ads_gclid'),
    gbraid: safeSessionValue('sw_ads_gbraid'),
    wbraid: safeSessionValue('sw_ads_wbraid')
  });

  const emitPurchase = (result, cartSnapshot, quoteSnapshot) => {
    const transactionId = String(result?.order?.id || result?.order?.name || '').trim();
    const currency = String(result?.currency || quoteSnapshot?.currency || '').trim().toUpperCase();
    const value = Number(result?.total ?? quoteSnapshot?.total);

    if (!transactionId || !currency || !Number.isFinite(value) || value < 0) return;

    const onceKey = 'sw_cod_purchase_v1:' + transactionId;
    try {
      if (sessionStorage.getItem(onceKey) === '1') return;
    } catch {}

    const byVariant = new Map(
      (quoteSnapshot?.items || []).map(item => [
        String(item?.variantId || '').split('/').pop(),
        item
      ])
    );

    const items = (cartSnapshot?.items || []).map((item, index) => {
      const quoted = byVariant.get(String(item?.variant_id || ''));
      const quotedPrice = Number(quoted?.unitPrice);
      const fallbackPrice = Number(item?.final_price ?? item?.original_price ?? 0) / 100;

      return {
        item_id: String(item?.sku || item?.variant_id || item?.product_id || index + 1),
        item_name: String(item?.product_title || item?.title || ''),
        item_variant: String(
          item?.variant_title && item.variant_title !== 'Default Title'
            ? item.variant_title
            : ''
        ),
        price: Number.isFinite(quotedPrice) ? quotedPrice : fallbackPrice,
        quantity: Math.max(1, Number(item?.quantity || 1))
      };
    });

    const purchase = {
      transaction_id: transactionId,
      value,
      currency,
      items
    };

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: 'purchase', ecommerce: purchase, sw_cod: true });
    } catch {}

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'purchase', purchase);

        if (googleAdsSendTo) {
          window.gtag('event', 'conversion', {
            send_to: googleAdsSendTo,
            transaction_id: transactionId,
            value,
            currency
          });
        }
      }
    } catch {}

    try {
      if (window.Shopify?.analytics?.publish) {
        Promise.resolve(
          window.Shopify.analytics.publish('souqwaffar:cod_purchase', purchase)
        ).catch(() => {});
      }
    } catch {}

    try {
      window.dispatchEvent(
        new CustomEvent('souqwaffar:cod_purchase', { detail: purchase })
      );
    } catch {}

    try {
      sessionStorage.setItem(onceKey, '1');
    } catch {}
  };

  const setSummaryExpanded = expanded => {
    if (!summary || !summaryToggle) return;
    summary.dataset.expanded = expanded ? 'true' : 'false';
    summaryToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    if (summaryToggleLabel) {
      summaryToggleLabel.textContent = expanded ? 'إخفاء ملخص الطلب' : 'عرض ملخص الطلب';
    }
  };

  summaryToggle?.addEventListener('click', () => {
    setSummaryExpanded(summary?.dataset.expanded !== 'true');
  });

  if (!supported.has(country)) {
    if (loading) loading.hidden = true;
    fail('هذه الدولة غير مفعلة للطلب حاليًا.');
    return;
  }

  if (!apiBase.startsWith('https://')) {
    if (loading) loading.hidden = true;
    fail('خدمة إتمام الطلب غير مهيأة.');
    return;
  }

  let cart = null;
  let quote = null;
  let quoteExpiresAt = 0;
  let quoteRequestId = 0;
  let countryConfig = null;
  let cartItemsForQuote = [];

  const uuid = () => {
    if (typeof crypto?.randomUUID === 'function') return crypto.randomUUID();

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, char => {
      const random = Math.floor(Math.random() * 16);
      const value = char === 'x' ? random : (random & 0x3) | 0x8;
      return value.toString(16);
    });
  };

  const idempotencyKey = uuid();

  async function json(url, options = {}) {
    const response = await fetch(url, {
      ...options,
      headers: {
        Accept: 'application/json',
        ...(options.body ? { 'Content-Type': 'application/json' } : {}),
        ...(options.headers || {})
      },
      credentials: 'omit',
      mode: 'cors'
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(data?.message || data?.error || 'تعذر الاتصال بالخدمة.');
    }

    return data;
  }

  function fillProvinces(provinces) {
    if (!province) return;

    province.replaceChildren();

    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'اختر المحافظة';
    province.append(placeholder);

    for (const item of provinces) {
      if (item?.isActive === false) continue;

      const option = document.createElement('option');
      option.value = String(item.id || item.name || '');
      option.textContent = String(item.name || '');
      if (item.shipping !== undefined && item.shipping !== null) {
        option.dataset.shipping = String(item.shipping);
      }
      province.append(option);
    }

    province.disabled = false;
  }

  function renderItems(cartItems, quoteItems, currency) {
    if (!itemsBox) return;

    const byVariant = new Map(
      (quoteItems || []).map(item => [String(item.variantId || '').split('/').pop(), item])
    );

    itemsBox.replaceChildren();

    for (const item of cartItems) {
      const quoted = byVariant.get(String(item.variant_id));
      const row = document.createElement('div');
      row.className = 'sw-cod-checkout__item';

      const media = document.createElement('div');
      media.className = 'sw-cod-checkout__item-media';

      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = String(item.product_title || item.title || '');
        image.loading = 'lazy';
        media.append(image);
      }

      const quantity = document.createElement('span');
      quantity.className = 'sw-cod-checkout__quantity';
      quantity.textContent = String(item.quantity || 1);
      media.append(quantity);

      const copy = document.createElement('div');
      copy.className = 'sw-cod-checkout__item-copy';

      const title = document.createElement('strong');
      title.textContent = String(item.product_title || item.title || '');

      const variant = document.createElement('span');
      variant.textContent =
        item.variant_title && item.variant_title !== 'Default Title'
          ? String(item.variant_title)
          : '';

      copy.append(title);
      if (variant.textContent) copy.append(variant);

      const price = document.createElement('b');
      price.className = 'sw-cod-checkout__item-price';

      if (quoted) {
        const lineTotal =
          quoted.lineTotal ?? Number(quoted.unitPrice || 0) * Number(item.quantity || 1);
        price.textContent = money(lineTotal, currency);
      } else {
        const cartLineMinor = Number(item.final_line_price ?? item.original_line_price ?? 0);
        price.textContent = money(cartLineMinor / 100, currency);
      }

      row.append(media, copy, price);
      itemsBox.append(row);
    }
  }

  function resetTotals(message) {
    quote = null;
    quoteExpiresAt = 0;

    const currency = countryConfig?.currency || 'EGP';
    const provisionalMinor = Number(cart?.items_subtotal_price ?? cart?.total_price ?? 0);
    const subtotal = provisionalMinor / 100;
    const defaultShipping = Number(
      countryConfig?.defaultShipping ??
      (countryConfig?.shippingMode === 'province' && country === 'EG' ? 105 : 0)
    );
    const provisional = money(subtotal, currency);
    const provisionalShipping = Number.isFinite(defaultShipping) ? defaultShipping : 0;
    const provisionalTotal = money(subtotal + provisionalShipping, currency);

    if (subtotalNode) subtotalNode.textContent = provisional;
    if (shippingNode) shippingNode.textContent = money(provisionalShipping, currency);
    if (totalNode) totalNode.textContent = provisionalTotal;
    if (summaryTotal) summaryTotal.textContent = provisionalTotal;

    if (loading) {
      loading.textContent = message || 'جاري حساب الإجمالي…';
      loading.hidden = false;
    }

    // Keep the action recoverable. Native required-field validation prevents
    // submission before a province is selected, while submit can retry quote creation.
    if (submit && province && !province.value) submit.disabled = false;
  }

  function applyQuote(nextQuote) {
    quote = nextQuote;
    quoteExpiresAt = Date.parse(nextQuote?.expiresAt || '') || 0;

    const currency = nextQuote.currency || countryConfig?.currency || 'EGP';

    renderItems(cart.items, nextQuote.items, currency);

    const subtotal = money(nextQuote.subtotal, currency);
    const shipping = money(nextQuote.shipping, currency);
    const total = money(nextQuote.total, currency);

    if (subtotalNode) subtotalNode.textContent = subtotal;
    if (shippingNode) shippingNode.textContent = shipping;
    if (totalNode) totalNode.textContent = total;
    if (summaryTotal) summaryTotal.textContent = total;
    if (loading) loading.hidden = true;
    if (ready) ready.hidden = false;
    if (submit) submit.disabled = false;
  }

  function applyProvincePreview() {
    if (!countryConfig) return false;

    const selected = province?.options?.[province.selectedIndex];
    if (!selected || !selected.value) {
      const currency = countryConfig.currency || 'EGP';
      const subtotalMinor = Number(cart?.items_subtotal_price ?? cart?.total_price ?? 0);
      const subtotal = subtotalMinor / 100;
      const defaultShipping = Number(
        countryConfig?.defaultShipping ??
        (countryConfig?.shippingMode === 'province' && country === 'EG' ? 105 : 0)
      );
      if (subtotalNode) subtotalNode.textContent = money(subtotal, currency);
      if (shippingNode) shippingNode.textContent = money(defaultShipping, currency);
      if (totalNode) totalNode.textContent = money(subtotal + defaultShipping, currency);
      if (summaryTotal) summaryTotal.textContent = money(subtotal + defaultShipping, currency);
      if (loading) loading.hidden = true;
      if (ready) ready.hidden = false;
      return true;
    }

    const currency = countryConfig.currency || 'EGP';
    const subtotalMinor = Number(cart?.items_subtotal_price ?? cart?.total_price ?? 0);
    const subtotal = subtotalMinor / 100;
    const shipping = Number(selected.dataset.shipping);

    if (Number.isFinite(shipping)) {
      if (subtotalNode) subtotalNode.textContent = money(subtotal, currency);
      if (shippingNode) shippingNode.textContent = money(shipping, currency);
      if (totalNode) totalNode.textContent = money(subtotal + shipping, currency);
      if (summaryTotal) summaryTotal.textContent = money(subtotal + shipping, currency);
      if (loading) loading.hidden = true;
      if (ready) ready.hidden = false;
      return true;
    }

    return false;
  }

  async function refreshQuote() {
    if (!cart || !countryConfig) return false;

    const provinceId = String(province?.value || '').trim();

    if (countryConfig.shippingMode === 'province' && !provinceId) {
      resetTotals('يتم احتساب شحن افتراضي 105 جنيه حتى اختيار المحافظة.');
      renderItems(cart.items, [], countryConfig.currency || 'EGP');
      if (ready) ready.hidden = false;
      return false;
    }

    const requestId = ++quoteRequestId;
    clearError();
    resetTotals('جاري حساب الشحن والإجمالي…');

    if (submit) {
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
    }

    try {
      const nextQuote = await json(apiBase + '/api/public/cod/quote', {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify({
          country,
          ...(provinceId ? { provinceId } : {}),
          items: cartItemsForQuote
        })
      });

      if (requestId !== quoteRequestId) return false;

      if (!nextQuote?.quoteToken) {
        throw new Error('Invalid quote token');
      }

      applyQuote(nextQuote);
      if (submit) submit.removeAttribute('aria-busy');
      return true;
    } catch (error) {
      if (requestId !== quoteRequestId) return false;

      fail(error instanceof Error ? error.message : 'تعذر حساب الإجمالي.');
      applyProvincePreview() || resetTotals('تعذر حساب الإجمالي. حاول مرة أخرى.');
      if (submit) {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      }
      const label = root.querySelector('[data-sw-submit-label]');
      if (label) label.textContent = 'إعادة المحاولة';
      return false;
    }
  }

  const handleProvinceChange = () => {
    if (!province || !province.value) {
      resetTotals('يتم احتساب شحن افتراضي 105 جنيه حتى اختيار المحافظة.');
      if (submit) {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      }
      const label = root.querySelector('[data-sw-submit-label]');
      if (label) label.textContent = 'تأكيد الطلب';
      return;
    }

    const label = root.querySelector('[data-sw-submit-label]');
    applyProvincePreview();
    if (label) label.textContent = 'جاري التحقق من الإجمالي…';

    refreshQuote().then(ok => {
      if (!ok) return;
      if (submit) {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      }
      if (label) label.textContent = 'تأكيد الطلب';
    });
  };

  province?.addEventListener('change', handleProvinceChange);

  async function load() {
    try {
      clearError();

      cart = await fetch(root.dataset.cartJsonUrl, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(response => response.json());

      if (!cart?.items?.length) {
        window.location.replace(root.dataset.cartUrl);
        return;
      }

      cartItemsForQuote = cart.items.map(item => ({
        variantId: 'gid://shopify/ProductVariant/' + item.variant_id,
        quantity: item.quantity
      }));

      countryConfig = await json(
        apiBase + '/api/public/cod/config?country=' + encodeURIComponent(country)
      );

      const provinces = Array.isArray(countryConfig?.provinces)
        ? countryConfig.provinces
        : [];

      if (!provinces.length) {
        throw new Error('Failed to load provinces');
      }

      fillProvinces(provinces);
      renderItems(cart.items, [], countryConfig.currency || 'EGP');

      if (ready) ready.hidden = false;
      if (submit) {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      }

      if (countryConfig.shippingMode === 'province') {
        resetTotals('اختر المحافظة لحساب الشحن والإجمالي.');
        const label = root.querySelector('[data-sw-submit-label]');
        if (label) label.textContent = 'تأكيد الطلب';

        // Browser autofill / restored form state fallback.
        if (province?.value) {
          handleProvinceChange();
        }
      } else {
        const ok = await refreshQuote();
        const label = root.querySelector('[data-sw-submit-label]');
        if (ok && label) label.textContent = 'تأكيد الطلب';
      }
    } catch (error) {
      if (loading) loading.hidden = true;
      fail(error instanceof Error ? error.message : 'تعذر تجهيز الطلب.');
    }
  }

  form?.addEventListener('submit', async event => {
    event.preventDefault();

    if (!form.reportValidity() || !submit) return;

    // Safety fallback: if a browser missed the select change event,
    // calculate the quote now instead of trapping the customer.
    if (!quote?.quoteToken && province?.value) {
      const refreshed = await refreshQuote();
      if (!refreshed || !quote?.quoteToken) return;
    }

    clearError();
    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');

    const label = root.querySelector('[data-sw-submit-label]');
    if (label) label.textContent = 'جاري تأكيد الطلب…';

    try {
      const quoteIsExpired =
        !quote?.quoteToken ||
        (quoteExpiresAt > 0 && Date.now() >= quoteExpiresAt - 5000);

      if (quoteIsExpired) {
        const refreshed = await refreshQuote();
        if (!refreshed || !quote?.quoteToken) {
          // refreshQuote already surfaced the real error. Do not replace it
          // with the misleading "expired total" message.
          submit.disabled = false;
          submit.removeAttribute('aria-busy');
          if (label) label.textContent = 'إعادة المحاولة';
          return;
        }

        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        if (label) label.textContent = 'جاري تأكيد الطلب…';
      }

      const fd = new FormData(form);
      const payload = {
        quoteToken: quote.quoteToken,
        customerName: String(fd.get('customerName') || '').trim(),
        phone: String(fd.get('phone') || '').trim(),
        address1: String(fd.get('address1') || '').trim(),
        provinceId: String(fd.get('provinceId') || '').trim(),
        idempotencyKey,
        attribution: getAttribution()
      };

      const result = await json(apiBase + '/api/public/cod/order', {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(payload)
      });

      emitPurchase(result, cart, quote);

      await fetch(root.dataset.cartClearUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).catch(() => {});

      if (workspace) workspace.hidden = true;
      if (success) success.hidden = false;

      const text = root.querySelector('[data-sw-cod-success-text]');
      const orderName = result?.order?.name || result?.orderName || '';

      if (text) {
        text.textContent = orderName
          ? 'رقم طلبك ' + orderName + ' — سنتواصل معك لتأكيد التوصيل.'
          : 'سنتواصل معك لتأكيد الطلب والتوصيل.';
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error) {
      fail(error instanceof Error ? error.message : 'تعذر تأكيد الطلب.');
      submit.disabled = false;
      submit.removeAttribute('aria-busy');
      if (label) label.textContent = 'تأكيد الطلب';
    }
  });

  load();
})();